import type { ReactNode } from "react";

import { classNames } from "@/utils/styling-utils";
import { RequiredAsterisk } from "./input/required-asterisk";

/**
 * Bruk 'Label' for enkeltstående input-elementer som skal ha sin egen label
 * Bruk 'LabelledBy' for flere input-elementer som alle skal ha samme label
 */
interface LabelAllProps {
  /**
   * Use 'hidden' for input elements with no visible label(s)
   */
  hidden?: boolean;
  required?: boolean;
  weight?: "bold";
}

interface LabelProps extends LabelAllProps {
  htmlFor: string;
  value: string;
}

export const Label = ({ hidden, htmlFor, required, value, weight }: LabelProps) => (
  <LabelWrapper hidden={hidden} weight={weight}>
    <label htmlFor={htmlFor}>{value}</label>
    {required && <RequiredAsterisk />}
  </LabelWrapper>
);

interface LabelledByProps extends LabelAllProps {
  id: string;
  value: string;
}

export const LabelledBy = ({ hidden, id, required, value, weight }: LabelledByProps) => (
  <LabelWrapper hidden={hidden} weight={weight}>
    <label id={id}>{value}</label>
    {required && <RequiredAsterisk />}
  </LabelWrapper>
);

interface LabelWrapperProps extends LabelAllProps {
  children: ReactNode;
}

const LabelWrapper = ({ children, hidden, weight }: LabelWrapperProps) => (
  <div className={classNames("label", hidden && "label--hidden", weight === "bold" && "label__weight--bold")}>
    {children}
  </div>
);
